export default function closeModal():void {
    gd.modal.hide()
}
